<div class="d-flex justify-content-end">
  <button *ngIf="addNewSurvey && !updateSurveyData" (click)="addNewSurvey = false"
    class="add-question-btn v4-btn-every py-2">
    {{ "Back" | translator }}
  </button>
</div>

<section [formGroup]="surveyForm" class="row m-0 grey-box" *ngIf="!addNewSurvey" [ngClass]="{ 'un-select': false }">
  <h4 *ngIf="fromRating == false" class="color font-600 bottom-line" [ngClass]="{ 'color-red': true }">
    <i class="fa-solid fa-square-poll-horizontal ml-2 mr-2 location"></i>{{ "Choose a poll" | translator }}
  </h4>

  <div class="col-lg-6 col-md-6 col-12 my-2" *ngIf="fromRating == false">
    <label class="label-ui" for="start_date"><i class="fa-solid fa-calendar-days ml-2 mr-2 result-icons"></i>
      {{ "Start Date" | translator }}&nbsp;:&nbsp;</label>
    <p-calendar [minDate]="today" [showTime]="true" [touchUI]="true" appendTo="body" class="w-100 mb-3"
      formControlName="start_date" [readonlyInput]="true"></p-calendar>
    <div class="error" *ngIf="isFieldError('start_date')">
      <div>{{ "Date is required" | translator }}</div>
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-12 my-2"
    *ngIf="!!surveyForm.get('start_date')?.getRawValue() && fromRating == false">
    <label class="label-ui" for="end_date"><i class="fa-regular fa-clock ml-2 mr-2 result-icons"></i>
      {{ "End Date" | translator }}&nbsp;:&nbsp;</label>
    <p-calendar [minDate]="startDate" [showTime]="true" [touchUI]="true" appendTo="body" id="end_date"
      formControlName="end_date" class="w-100 mb-3"></p-calendar>
    <div class="error" *ngIf="isFieldError('end_date')">
      <div>{{ "start time is required" | translator }}</div>
    </div>
  </div>
  <div class="flex-mob-web my-2">
    <div class="m-1" *ngIf="fromRating == false">
      <p-selectButton class="v4-active d-flex justify-content-end" [options]="blockOptions" formControlName="video_mode"
        optionLabel="name" optionValue="value"></p-selectButton>
    </div>
    <div class="m-1">
      <button (click)="addNewSurvey = true" class="ms-btn-onclick">
        {{ "Add Survey" | translator }}<i class="pi pi-plus-circle mx-2"></i>
      </button>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-12 my-2 p-0" *ngFor="let survey of surveys">
    <div class="card card-shaddow m-1 cursor-pointer"
      [ngClass]="{ 'dynamic-card-active': selectedSurvey?._id == survey._id }" (click)="
        selectedSurvey = survey;
        surveyForm.get('surveyId')?.setValue(survey._id);
        selectSurvey(survey._id)
      ">
      <h4 class="label-ui mt-2">
        <i class="fa-solid fa-chart-line ml-2 mr-2 result-icons"></i>{{ survey.surveyTitle }}
      </h4>
      <p class="label-data m-0">{{ survey.surveyTitle }}</p>
      <span class="scroll-desc">
        <p class="label-text">{{ survey.description }}</p>
      </span>
      <button class="v4-btn-every py-2 mb-2" (click)="openAddQuestion(survey)">
        <i class="pi pi-external-link v4-ml-2"></i>{{ "Add Questions" | translator }}
      </button>
    </div>
  </div>
  <div class="error" *ngIf="isFieldError('surveyId')">
    <div>{{ "Please Select a survey" | translator }}</div>
  </div>
</section>

<app-survey *ngIf="addNewSurvey" [createSurveyFromCourse]="true" [fromRating]="fromRating"
  (newSurvey)="addedNewSurveySession()" [trainingTypeId]="trainingTypeId" [trainingSurveyTypeId]="
    fromRating ? fromImpact ? '66f2c9f0788bfe7c2ebd8269' : '6692508954a2ffed9d79163f' : '65b4e2d8cab47de5ee5a2415'
  "></app-survey>

<div class="d-flex justify-content-center" *ngIf="!addNewSurvey && !fromRating">
  <button type="button" (click)="createSurveySession()" class="ms-btn-onclick mb-ten">
    {{ "OK" | translator }} <i class="fa-regular fa-pen-to-square mx-2"></i>
  </button>
</div>